
(() => {
  'use strict';

  /* =========================================
     GLOBAL LOADER
  ========================================= */

  function hideLoader() {
    const loader = document.getElementById('global-loader');
    if (!loader) return;

    loader.style.opacity = '0';

    window.setTimeout(() => {
      loader.style.display = 'none';
    }, 300);
  }


  /* =========================================
     PREDICTIVE SEARCH
  ========================================= */

  function initSearch() {
    const input = document.getElementById('predictive-search-input');
    const resultsBox = document.getElementById('predictive-search-results');

    if (!input || !resultsBox || input.dataset.themeSearchBound) return;

    input.dataset.themeSearchBound = 'true';

    let timer;
    let controller;
    let requestId = 0;

    const escapeHTML = (value) =>
      String(value ?? '').replace(/[&<>"']/g, (character) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character]));

    const root = window.Shopify?.routes?.root || '/';

    input.addEventListener('input', () => {
      window.clearTimeout(timer);

      if (controller) controller.abort();

      const id = ++requestId;
      const query = input.value.trim();

      resultsBox.innerHTML = '';

      if (query.length < 3) return;

      timer = window.setTimeout(async () => {
        controller = new AbortController();

        try {
          const response = await fetch(
            `${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection`,
            { signal: controller.signal }
          );

          if (!response.ok) {
            throw new Error(`Search failed: ${response.status}`);
          }

          const data = await response.json();

          if (id !== requestId || !data.resources?.results) return;

          const {
            products = [],
            collections = []
          } = data.resources.results;

          const currency = escapeHTML(
            window.Shopify?.currency?.active || ''
          );

          let html = products.slice(0, 4).map((product) => {
            const image = product.featured_image?.url;

            const imageURL = image
              ? `${image}${image.includes('?') ? '&' : '?'}width=80`
              : '';

            return `
              <a href="${escapeHTML(product.url)}" class="search-item">
                ${image ? `
                  <div class="search-img">
                    <img
                      loading="lazy"
                      data-avada-lazy
                      src="${escapeHTML(imageURL)}"
                      alt="${escapeHTML(product.title)}"
                      width="80"
                      height="80"
                    >
                  </div>
                ` : ''}

                <div class="search-info">
                  <p class="search-title">${escapeHTML(product.title)}</p>
                  <p class="search-price">
                    ${(product.price / 100).toFixed(2)} ${currency}
                  </p>
                </div>
              </a>
            `;
          }).join('');

          html += collections.slice(0, 3).map((collection) => `
            <a href="${escapeHTML(collection.url)}"
               class="search-item collection-item">
              <div class="search-info">
                <p class="search-label">Collection</p>
                <p class="search-title">
                  ${escapeHTML(collection.title)}
                </p>
              </div>
            </a>
          `).join('');

          html += `
            <a class="search-item view-all"
               href="${root}search?q=${encodeURIComponent(query)}&type=product">
              View all results
            </a>
          `;

          resultsBox.innerHTML = html;

        } catch (error) {
          if (error.name !== 'AbortError' && id === requestId) {
            resultsBox.innerHTML = '';
          }
        }

      }, 250);
    });
  }


  /* =========================================
     MOBILE FILTER DRAWER
     InstantClick Compatible
  ========================================= */

  function setFilterDrawer(open) {
    // Find current page elements every time
    const sidebar = document.querySelector(
      '[data-sidebar]:not([data-product-sidebar])'
    );

    const overlay = document.querySelector(
      '[data-filter-overlay]'
    );

    if (!sidebar || !overlay) return;

    sidebar.classList.toggle('is-open', open);

    overlay.classList.toggle('is-open', open);

    document.body.classList.toggle('filter-open', open);
  }



/* =========================================
   MOBILE FILTER CLICK EVENTS
   iOS Safari Compatible
========================================= */

document.addEventListener('click', function (event) {

  const target = event.target instanceof Element
    ? event.target
    : event.target?.parentElement;

  if (!target) return;

  const openButton = target.closest('[data-filter-open]');
  const closeButton = target.closest('[data-filter-close]');
  const overlay = target.closest('[data-filter-overlay]');

  if (openButton) {
    event.preventDefault();
    setFilterDrawer(true);
    return;
  }

  if (closeButton || overlay) {
    event.preventDefault();
    setFilterDrawer(false);
  }

}, true);



  /* =========================================
     CLOSE FILTER ON ESCAPE
  ========================================= */

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setFilterDrawer(false);
    }
  });


  /* =========================================
     MOBILE MEGA MENU
     Existing Functionality Preserved
  ========================================= */

  document.addEventListener('click', (event) => {

    const button = event.target.closest('.mobile-menu-toggle');

    if (!button) return;

    const item = button.closest('.mobile-menu-item');

    if (!item) return;

    event.preventDefault();
    event.stopPropagation();

    item.classList.toggle('open');

  });


  /* =========================================
     INITIALIZATION
  ========================================= */

  function init() {

    initSearch();

    if (window.InstantClick) {

      // Reinitialize after InstantClick page navigation
      window.InstantClick.on('change', () => {

        initSearch();

        hideLoader();

        // Close filter drawer on new page
        setFilterDrawer(false);

      });

      window.InstantClick.on('receive', hideLoader);
    }

    if (document.readyState === 'complete') {
      hideLoader();
    } else {
      window.addEventListener('load', hideLoader, {
        once: true
      });
    }
  }


  /* =========================================
     DOM READY
  ========================================= */

  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', init, {
      once: true
    });

  } else {

    init();

  }

})();
